export async function loadRuntimeConfig() {
  try {
    // Try to load from runtime config first
    const res = await fetch('/app-config.json', { 
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache'
      }
    });
    
    if (!res.ok) {
      console.warn('Runtime config not found, using build-time defaults');
      throw new Error('Config fetch failed');
    }
    
    const cfg = await res.json();
    window.__APP_CONFIG__ = cfg;
    return cfg;
  } catch (e) {
    console.warn('Using build-time configuration fallback');
    
    // Fallback to build-time environment variables
    // Note: API keys are now managed server-side for security
    const fallbackConfig = {
      apiBase: process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000',
      systemName: process.env.VUE_APP_SYSTEM_NAME || 'Safa&Comfort',
      originLat: parseFloat(process.env.VUE_APP_ORIGIN_LAT) || 30.0443879,
      originLng: parseFloat(process.env.VUE_APP_ORIGIN_LNG) || 31.2357257
    };
    
    window.__APP_CONFIG__ = fallbackConfig;
    return fallbackConfig;
  }
}

export function getCfg(key, fallback) {
  return (window.__APP_CONFIG__ && window.__APP_CONFIG__[key]) ?? fallback;
}
  